/* Rudix Booking — native booking UI for the Shopify theme.
 * No colours or fonts are set here; styling lives in snippets/rudix-booking-ui.liquid
 * and inherits the theme's CSS variables. Analytics: window.dataLayer + Shopify.analytics.publish. */
(function () {
  'use strict';
  var TZ = 'America/Toronto';
  // In-store types are always shown in store time; phone/online types in the customer's own zone.
  var BROWSER_TZ = (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || TZ; } catch (e) { return TZ; } })();

  function el(tag, attrs, kids) {
    var n = document.createElement(tag);
    if (attrs) for (var k in attrs) {
      if (attrs[k] == null || attrs[k] === false) continue;
      if (k === 'class') n.className = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else if (k.slice(0, 2) === 'on') n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k] === true ? '' : attrs[k]);
    }
    (kids || []).forEach(function (c) { if (c != null) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) { var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16); });
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymdInTz(ms) { return new Intl.DateTimeFormat('en-CA', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ms)); }
  function addDays(s, n) { var p = s.split('-'); var d = new Date(Date.UTC(+p[0], +p[1] - 1, +p[2] + n)); return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function dow(s) { var p = s.split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2])).getUTCDay(); }
  function noonUtc(s) { return new Date(s + 'T12:00:00Z'); }

  function Booking(root) {
    this.root = root;
    var d = root.dataset;
    this.opts = {
      api: (window.RUDIX_BOOKING_API_OVERRIDE || d.api || '').replace(/\/$/, ''),
      only: (d.types || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean),
      preselect: d.defaultType || '',
      hour12: d.timeFormat === '24' ? false : (d.timeFormat === '12' ? true : !/^(fr|de|es|it|nl|pt)/.test(document.documentElement.lang || 'en')),
      locale: document.documentElement.lang || 'en-CA',
      showDesc: d.showDescriptions !== 'false',
      hostPhoto: d.hostPhoto || '',
      bookUrl: d.bookUrl || location.pathname
    };
    // Keep preview/view params (e.g. ?preview_theme_id=…&view=…) in self-links.
    this.linkTo = function (extra) {
      var u = new URL(location.href); ['manage', 'action', 'type'].forEach(function (k) { u.searchParams.delete(k); });
      Object.keys(extra || {}).forEach(function (k) { u.searchParams.set(k, extra[k]); });
      return u.pathname + u.search;
    };
    this.demo = !this.opts.api;
    this.state = { step: 'type', type: null, month: null, date: null, slot: null, days: {}, booking: null, manage: null, renderedAt: Date.now(), idem: uuid() };
    this.$ = {
      status: root.querySelector('[data-rb-status]'),
      body: root.querySelector('[data-rb-body]'),
      summary: root.querySelector('[data-rb-summary]'),
      steps: root.querySelector('[data-rb-steps]')
    };
    this.started = false;
    this.init();
  }

  Booking.prototype.track = function (event, params) {
    var p = Object.assign({ event: event, booking_widget: 'rudix_booking', booking_demo: this.demo }, params || {});
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(p);
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(event, p); } catch (e) {}
    try { this.root.dispatchEvent(new CustomEvent('rudix-booking:' + event, { bubbles: true, detail: p })); } catch (e) {}
  };
  Booking.prototype.typeParams = function (t) {
    t = t || this.state.type;
    return t ? { appointment_type: t.id, appointment_title: t.title, appointment_duration: t.durationMin, appointment_location: t.location.kind } : {};
  };
  Booking.prototype.markStarted = function () {
    if (this.started) return; this.started = true;
    this.track('booking_start', {});
  };

  Booking.prototype.zone = function (t) { t = t || this.state.type; return t && t.location && t.location.kind !== 'in_person' ? BROWSER_TZ : TZ; };
  Booking.prototype.fmtTime = function (ms, zone) {
    return new Date(ms).toLocaleTimeString(this.opts.hour12 ? 'en-US' : 'en-GB', { timeZone: zone || this.zone(), hour: 'numeric', minute: '2-digit', hour12: this.opts.hour12 });
  };
  // Slot label: time in the display zone, plus the weekday if that falls on another day than the store's date.
  Booking.prototype.fmtSlot = function (ms) {
    var z = this.zone(), t = this.fmtTime(ms, z);
    if (z === TZ) return t;
    var ld = new Intl.DateTimeFormat('en-CA', { timeZone: z, year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(ms));
    return ld === ymdInTz(ms) ? t : t + ' (' + new Date(ms).toLocaleDateString(this.opts.locale, { timeZone: z, weekday: 'short' }) + ')';
  };
  Booking.prototype.fmtWhen = function (ms, o) {
    var z = this.zone();
    return new Date(ms).toLocaleDateString(this.opts.locale, Object.assign({ timeZone: z }, o || { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' })) + ' at ' + this.fmtTime(ms, z) + (z !== TZ ? ' (' + this.zoneName(z) + ')' : '');
  };
  Booking.prototype.zoneName = function (z) {
    try { var p = new Intl.DateTimeFormat(this.opts.locale, { timeZone: z, timeZoneName: 'short' }).formatToParts(new Date()).filter(function (x) { return x.type === 'timeZoneName'; })[0]; return p ? p.value : z; } catch (e) { return z; }
  };
  Booking.prototype.timesNote = function () {
    var z = this.zone();
    if (z === TZ) return this.t('times');
    return 'Times shown in your time zone (' + z.replace(/_/g, ' ') + ', ' + this.zoneName(z) + ').';
  };
  Booking.prototype.fmtDate = function (s, o) { return noonUtc(s).toLocaleDateString(this.opts.locale, Object.assign({ timeZone: 'UTC' }, o)); };
  Booking.prototype.say = function (msg) { this.$.status.textContent = ''; var s = this.$.status; setTimeout(function () { s.textContent = msg; }, 30); };

  // ---------- data ----------
  Booking.prototype.get = function (path) {
    var self = this;
    if (this.demo) return Promise.resolve(this.demoApi('GET', path));
    return fetch(this.opts.api + path, { credentials: 'omit' }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw Object.assign(new Error(j.error || 'error'), { status: r.status, body: j }); return j; }); }).catch(function (e) { self.lastError = e; throw e; });
  };
  Booking.prototype.post = function (path, body) {
    if (this.demo) return Promise.resolve(this.demoApi('POST', path, body));
    return fetch(this.opts.api + path, { method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw Object.assign(new Error(j.error || 'error'), { status: r.status, body: j }); return j; }); });
  };
  // Preview mode: same slot engine as the backend, nothing leaves the browser.
  Booking.prototype.demoApi = function (method, path, body) {
    var C = window.RudixBookingCore, D = C.demo;
    if (path === '/api/config') return { testMode: true, timezone: TZ, windowDays: D.settings.windowDays, types: D.types, holidays: [] };
    if (path.indexOf('/api/slots') === 0) {
      var q = new URLSearchParams(path.split('?')[1]); var t = D.types.filter(function (x) { return x.id === q.get('type'); })[0];
      var res = C.slots.generateSlots({ type: t, schedule: D.schedules[t.scheduleId], settings: D.settings, now: Date.now(), fromDate: q.get('from'), toDate: q.get('to'), bookings: [], busy: [] });
      return { today: res.today, lastDate: res.lastDate, days: res.days.map(function (d) { return { date: d.date, reason: d.reason, holiday: d.holiday, slots: d.slots.map(function (s) { return { start: new Date(s.start).toISOString(), seatsLeft: s.seatsLeft }; }) }; }) };
    }
    if (method === 'POST' && path === '/api/bookings') {
      var ty = D.types.filter(function (x) { return x.id === body.typeId; })[0];
      return { ok: true, demo: true, booking: { id: 'preview', typeId: ty.id, typeTitle: ty.title, durationMin: ty.durationMin, start: body.start, end: new Date(Date.parse(body.start) + ty.durationMin * 60000).toISOString(), status: 'confirmed', location: ty.location, name: body.name, email: body.email }, manageToken: null };
    }
    return {};
  };

  // ---------- init ----------
  Booking.prototype.init = function () {
    var self = this;
    var params = new URLSearchParams(location.search);
    this.render('loading');
    this.get('/api/config').then(function (cfg) {
      self.cfg = cfg;
      var types = cfg.types;
      if (self.opts.only.length) types = types.filter(function (t) { return self.opts.only.indexOf(t.id) >= 0; });
      self.types = types;
      var manage = params.get('manage');
      if (manage) return self.loadManage(manage, params.get('action'));
      var want = params.get('type') || params.get('calendly') || self.opts.preselect;
      var pre = want && types.filter(function (t) { return t.id === want || (t.legacySlugs || []).indexOf(want) >= 0; })[0];
      if (pre) { self.pickType(pre, true); } else if (types.length === 1) { self.pickType(types[0], true); } else self.render('type');
    }).catch(function () { self.render('error'); });
    this.root.addEventListener('pointerdown', function () { self.markStarted(); }, { once: true });
    this.root.addEventListener('keydown', function () { self.markStarted(); }, { once: true });
  };

  Booking.prototype.loadManage = function (token, action) {
    var self = this;
    this.state.manage = { token: token };
    return this.get('/api/manage/' + encodeURIComponent(token)).then(function (j) {
      self.state.manage.booking = j.booking;
      var t = self.cfg.types.filter(function (x) { return x.id === j.booking.typeId; })[0];
      self.state.type = t || { id: j.booking.typeId, title: j.booking.typeTitle, durationMin: j.booking.durationMin, location: j.booking.location, questions: [] };
      if (action === 'reschedule' && j.booking.status === 'confirmed') { self.state.rescheduling = true; self.openCalendar(); }
      else self.render('manage');
    }).catch(function () { self.render('manage-invalid'); });
  };

  // ---------- steps ----------
  Booking.prototype.pickType = function (t, silent) {
    this.state.type = t; this.state.date = null; this.state.slot = null; this.state.days = {};
    if (!silent) this.markStarted();
    this.track('type_selected', this.typeParams(t));
    this.openCalendar();
  };
  Booking.prototype.openCalendar = function () {
    var today = ymdInTz(Date.now());
    this.state.month = this.state.month || today.slice(0, 7);
    this.render('date');
    this.loadMonth(this.state.month);
  };
  Booking.prototype.loadMonth = function (ym) {
    var self = this, today = ymdInTz(Date.now());
    var first = ym + '-01', last = addDays(addDays(first, 32).slice(0, 7) + '-01', -1);
    var from = first < today ? today : first;
    var key = this.state.type.id + '|' + ym;
    if (this.state.days[key]) return this.drawMonth();
    this.state.loading = true; this.drawMonth();
    var q = '/api/slots?type=' + encodeURIComponent(this.state.type.id) + '&from=' + from + '&to=' + last + (this.state.manage ? '&manage=' + encodeURIComponent(this.state.manage.token) : '');
    if (last < from) { this.state.days[key] = { days: [] }; this.state.loading = false; return this.drawMonth(); }
    this.get(q).then(function (j) {
      self.state.days[key] = j; self.state.loading = false; self.state.lastDate = j.lastDate;
      if (!self.state.date) {
        var firstOpen = j.days.filter(function (d) { return d.slots.length; })[0];
        if (firstOpen && window.matchMedia('(min-width: 750px)').matches) self.state.date = firstOpen.date;
        if (!firstOpen && ym === today.slice(0, 7)) { // nothing left this month: jump ahead once
          var next = addDays(last, 1).slice(0, 7);
          if (!self.state.autoJumped) { self.state.autoJumped = true; self.state.month = next; return self.loadMonth(next); }
        }
      }
      self.drawMonth();
    }).catch(function (e) { self.state.loading = false; self.render(e && e.status === 503 ? 'unavailable' : 'error'); });
  };
  Booking.prototype.monthData = function () { var k = this.state.type.id + '|' + this.state.month; return this.state.days[k]; };

  Booking.prototype.pickSlot = function (slot) {
    this.state.slot = slot;
    var t = Date.parse(slot.start);
    this.track('slot_selected', Object.assign(this.typeParams(), { appointment_date: this.state.date, appointment_time: this.fmtTime(t), days_ahead: Math.round((t - Date.now()) / 86400000) }));
    if (this.state.rescheduling) return this.render('confirm-reschedule');
    this.render('details');
  };

  Booking.prototype.submit = function (form) {
    var self = this, t = this.state.type, f = new FormData(form);
    var answers = {};
    (t.questions || []).forEach(function (q) { answers[q.id] = (f.get('q_' + q.id) || '').toString(); });
    var params = new URLSearchParams(location.search);
    var source = { page: location.pathname, referrer: document.referrer ? document.referrer.slice(0, 300) : '' };
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'].forEach(function (k) { var v = params.get(k) || sessionStorage.getItem('rb_' + k); if (v) source[k] = v; });
    var guests = (f.get('guests') || '').toString().split(/[\s,;]+/).filter(Boolean);
    var body = { typeId: t.id, start: this.state.slot.start, name: t.nameFormat === 'first_last' ? ((f.get('firstName') || '') + ' ' + (f.get('lastName') || '')).trim() : (f.get('name') || '').toString(),
      firstName: (f.get('firstName') || '').toString(), lastName: (f.get('lastName') || '').toString(), guests: guests, timeZone: BROWSER_TZ, email: (f.get('email') || '').toString(), answers: answers, idempotencyKey: this.state.idem, renderedAt: this.state.renderedAt, website: (f.get('website') || '').toString(), source: source };
    var btn = form.querySelector('[type=submit]'); btn.disabled = true; btn.setAttribute('aria-busy', 'true');
    var err = form.querySelector('[data-rb-form-error]'); err.textContent = '';
    this.post('/api/bookings', body).then(function (j) {
      self.state.booking = j.booking; self.state.manageToken = j.manageToken;
      if (j.booking) self.track('booking_complete', Object.assign(self.typeParams(), { appointment_date: self.state.date, appointment_time: self.fmtTime(Date.parse(j.booking.start)), booking_id: j.booking.id, value: 0, currency: 'CAD', conversion: true }));
      self.state.idem = uuid();
      self.render('done');
    }).catch(function (e) {
      btn.disabled = false; btn.removeAttribute('aria-busy');
      var b = e.body || {};
      if (e.status === 409) { self.state.days = {}; err.textContent = self.t('taken'); self.state.slot = null; setTimeout(function () { self.openCalendar(); self.say(self.t('taken')); }, 1600); return; }
      if (b.field) {
        var name = ['email', 'name', 'firstName', 'lastName', 'guests'].indexOf(b.field) >= 0 ? b.field : b.field.indexOf('q_') === 0 ? b.field : null;
        var input = name && form.querySelector('[name="' + name + '"]');
        err.textContent = b.field === 'too_fast' ? self.t('tooFast') : b.field === 'guests' ? 'Please check the guest emails (up to 10, separated by commas).' : self.t('check');
        if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
        return;
      }
      err.textContent = e.status === 429 ? self.t('rate') : self.t('error');
    });
  };

  Booking.prototype.doCancel = function () {
    var self = this, m = this.state.manage;
    this.post('/api/manage/' + encodeURIComponent(m.token) + '/cancel', { reason: (this.root.querySelector('[name=reason]') || {}).value || '' }).then(function (j) {
      m.booking = j.booking; self.track('booking_cancel', Object.assign(self.typeParams(), { booking_id: j.booking.id })); self.render('manage');
    }).catch(function () { self.say(self.t('error')); });
  };
  Booking.prototype.doReschedule = function () {
    var self = this, m = this.state.manage;
    this.post('/api/manage/' + encodeURIComponent(m.token) + '/reschedule', { start: this.state.slot.start, reason: (this.root.querySelector('[name=rsreason]') || {}).value || '' }).then(function (j) {
      m.booking = j.booking; self.state.rescheduling = false; self.track('booking_reschedule', Object.assign(self.typeParams(), { booking_id: j.booking.id, appointment_date: self.state.date }));
      self.render('manage', { rescheduled: true });
    }).catch(function (e) { if (e.status === 409) { self.state.days = {}; self.openCalendar(); self.say(self.t('taken')); } else self.say(self.t('error')); });
  };

  // ---------- copy ----------
  var COPY = {
    chooseType: 'Choose an appointment', chooseDate: 'Choose a date', chooseTime: 'Choose a time', details: 'Your details', done: 'You’re booked',
    times: 'Times shown in Toronto time (ET).', noTimes: 'No times left on this day.', closedDay: 'Closed', back: 'Back', change: 'Change',
    name: 'Full name', email: 'Email', confirm: 'Confirm appointment', optional: 'optional',
    taken: 'Sorry — that time was just taken. Please choose another.', check: 'Please check the highlighted field.', tooFast: 'Please take a moment to review, then confirm again.',
    rate: 'Too many attempts. Please try again later or call us.', error: 'Something went wrong. Please try again, or call us.', loading: 'Loading available times…',
    unavailable: 'Online booking is temporarily unavailable. Please call or email us and we’ll book you in.',
    visit: 'Visit the showroom', remote: 'By phone or video', prev: 'Previous month', next: 'Next month', min: 'min',
    demo: 'Preview mode — this is a demonstration. No appointment will be booked.'
  };
  Booking.prototype.t = function (k) { return COPY[k] || k; };

  // ---------- rendering ----------
  Booking.prototype.setStep = function (step) {
    this.state.step = step;
    this.root.setAttribute('data-rb-step', step);
    var map = { type: 1, date: 2, details: 3, done: 4, 'confirm-reschedule': 3 };
    var n = map[step] || 0;
    this.$.steps.hidden = !n || !!this.state.manage;
    Array.prototype.forEach.call(this.$.steps.querySelectorAll('li'), function (li, i) {
      li.classList.toggle('is-done', i + 1 < n); li.classList.toggle('is-current', i + 1 === n);
      if (i + 1 === n) li.setAttribute('aria-current', 'step'); else li.removeAttribute('aria-current');
    });
  };
  Booking.prototype.focusHeading = function () {
    var h = this.$.body.querySelector('h2, h3'); if (h) { h.setAttribute('tabindex', '-1'); h.focus({ preventScroll: true }); }
    var top = this.root.getBoundingClientRect().top;
    if (top < 0 || top > window.innerHeight * 0.6) this.root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  Booking.prototype.render = function (view, extra) {
    var self = this, B = this.$.body;
    B.innerHTML = '';
    this.setStep(view);
    this.drawSummary(view);
    if (this.demo && view !== 'loading') B.appendChild(el('p', { class: 'rb-note rb-note--demo', role: 'note', text: this.t('demo') }));
    switch (view) {
      case 'loading': B.appendChild(el('div', { class: 'rb-skeleton', 'aria-hidden': 'true' }, [el('span'), el('span'), el('span')])); this.say(this.t('loading')); break;
      case 'error': B.appendChild(el('p', { class: 'rb-note', role: 'alert', text: this.t('error') })); break;
      case 'unavailable': B.appendChild(el('p', { class: 'rb-note', role: 'alert', text: this.t('unavailable') })); break;
      case 'type': this.drawTypes(B); break;
      case 'date': this.drawCalendarShell(B); break;
      case 'details': this.drawDetails(B); break;
      case 'done': this.drawDone(B); break;
      case 'manage': this.drawManage(B, extra || {}); break;
      case 'manage-invalid': B.appendChild(el('p', { class: 'rb-note', role: 'alert', text: 'This link has expired or is not valid. Please contact us and we’ll help.' })); break;
      case 'confirm-reschedule': this.drawConfirmReschedule(B); break;
    }
    if (view !== 'loading' && view !== 'date') this.focusHeading();
  };

  Booking.prototype.drawSummary = function (view) {
    var S = this.$.summary, t = this.state.type;
    S.innerHTML = '';
    S.hidden = !t || view === 'type' || view === 'done' || view === 'loading' || view === 'manage-invalid';
    var lay = this.root.querySelector('.rb-layout'); if (lay) lay.classList.toggle('has-summary', !S.hidden);
    if (S.hidden) return;
    var host = (this.cfg && this.cfg.host) || {};
    var photo = this.opts.hostPhoto || host.photoUrl;
    var hostRow = host.name ? el('div', { class: 'rb-host' }, [photo ? el('img', { class: 'rb-host__img', src: photo, alt: '', width: 40, height: 40, loading: 'lazy' }) : null, el('span', { class: 'rb-host__name', text: 'with ' + host.name })]) : null;
    var items = [hostRow, el('p', { class: 'rb-summary__title', text: t.title }), el('p', { class: 'rb-summary__meta' }, [el('span', { class: 'rb-icon rb-icon--clock', 'aria-hidden': 'true' }), t.durationMin + ' ' + this.t('min')]), el('p', { class: 'rb-summary__meta' }, [el('span', { class: 'rb-icon rb-icon--' + (t.location.kind === 'in_person' ? 'pin' : t.location.kind === 'video' ? 'video' : 'phone'), 'aria-hidden': 'true' }), t.location.label || ''])];
    if (this.state.slot && (view === 'details' || view === 'confirm-reschedule')) {
      var st = Date.parse(this.state.slot.start);
      items.push(el('p', { class: 'rb-summary__meta rb-summary__when' }, [el('span', { class: 'rb-icon rb-icon--cal', 'aria-hidden': 'true' }), this.fmtWhen(st, { weekday: 'long', month: 'long', day: 'numeric' })]));
    }
    if (this.opts.showDesc && t.description && view === 'date') items.push(el('p', { class: 'rb-summary__desc', text: t.description }));
    var self = this;
    if (!this.state.manage && this.types && this.types.length > 1) items.push(el('button', { type: 'button', class: 'rb-link', text: this.t('change'), 'aria-label': 'Change appointment type', onclick: function () { self.state.type = null; self.state.slot = null; self.state.date = null; self.render('type'); } }));
    items.forEach(function (i) { if (i) S.appendChild(i); });
  };

  Booking.prototype.drawTypes = function (B) {
    var self = this;
    B.appendChild(el('h2', { class: 'rb-h', text: this.t('chooseType') }));
    var groups = [{ label: this.t('visit'), items: this.types.filter(function (t) { return t.location.kind === 'in_person'; }) }, { label: this.t('remote'), items: this.types.filter(function (t) { return t.location.kind !== 'in_person'; }) }];
    groups.forEach(function (g) {
      if (!g.items.length) return;
      var gid = 'rb-g-' + Math.random().toString(36).slice(2, 8);
      B.appendChild(el('h3', { class: 'rb-group', id: gid, text: g.label }));
      var ul = el('ul', { class: 'rb-types', role: 'list', 'aria-labelledby': gid });
      g.items.forEach(function (t) {
        ul.appendChild(el('li', null, [el('button', { type: 'button', class: 'rb-type', onclick: function () { self.pickType(t); } }, [
          el('span', { class: 'rb-type__title', text: t.title }),
          el('span', { class: 'rb-type__meta' }, [el('span', { class: 'rb-icon rb-icon--clock', 'aria-hidden': 'true' }), t.durationMin + ' ' + self.t('min'), el('span', { class: 'rb-dot', 'aria-hidden': 'true', text: '·' }), t.location.kind === 'in_person' ? 'In person' : (t.location.kind === 'video' ? 'Video call (Google Meet)' : 'Phone call')]),
          self.opts.showDesc && t.description ? el('span', { class: 'rb-type__desc', text: t.description }) : null,
          el('span', { class: 'rb-type__arrow', 'aria-hidden': 'true' })
        ])]));
      });
      B.appendChild(ul);
    });
  };

  Booking.prototype.drawCalendarShell = function (B) {
    var self = this;
    var head = el('div', { class: 'rb-row' }, [el('h2', { class: 'rb-h', text: this.state.rescheduling ? 'Choose a new time' : this.t('chooseDate') })]);
    B.appendChild(head);
    this.$.cal = el('div', { class: 'rb-cal' });
    this.$.times = el('div', { class: 'rb-times', 'aria-live': 'polite' });
    B.appendChild(el('div', { class: 'rb-picker' }, [this.$.cal, this.$.times]));
    B.appendChild(el('p', { class: 'rb-fine', text: this.timesNote() }));
    if (this.types && this.types.length > 1 && !this.state.manage) B.appendChild(el('button', { type: 'button', class: 'rb-link rb-back', text: '← ' + this.t('back'), onclick: function () { self.state.type = null; self.render('type'); } }));
    this.drawMonth();
  };

  Booking.prototype.drawMonth = function () {
    if (this.state.step !== 'date' || !this.$.cal) return;
    var self = this, C = this.$.cal, ym = this.state.month, data = this.monthData();
    var today = ymdInTz(Date.now());
    var byDate = {}; if (data) data.days.forEach(function (d) { byDate[d.date] = d; });
    C.innerHTML = '';
    var first = ym + '-01', title = this.fmtDate(first, { month: 'long', year: 'numeric' });
    var lastDate = this.state.lastDate || addDays(today, (this.cfg && this.cfg.windowDays) || 56);
    var canPrev = ym > today.slice(0, 7), canNext = addDays(first, 32).slice(0, 7) <= lastDate.slice(0, 7);
    C.appendChild(el('div', { class: 'rb-cal__head' }, [
      el('button', { type: 'button', class: 'rb-cal__nav rb-cal__nav--prev', 'aria-label': this.t('prev'), disabled: !canPrev, onclick: function () { self.state.month = addDays(first, -1).slice(0, 7); self.state.date = null; self.loadMonth(self.state.month); } }),
      el('p', { class: 'rb-cal__title', id: 'rb-cal-title', 'aria-live': 'polite', text: title }),
      el('button', { type: 'button', class: 'rb-cal__nav rb-cal__nav--next', 'aria-label': this.t('next'), disabled: !canNext, onclick: function () { self.state.month = addDays(first, 32).slice(0, 7); self.state.date = null; self.loadMonth(self.state.month); } })
    ]));
    var grid = el('div', { class: 'rb-cal__grid' + (this.state.loading ? ' is-loading' : ''), role: 'grid', 'aria-labelledby': 'rb-cal-title' });
    var wk = el('div', { class: 'rb-cal__row rb-cal__dow', role: 'row' });
    ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].forEach(function (d, i) { wk.appendChild(el('span', { role: 'columnheader', 'aria-label': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'][i], text: d.slice(0, 2) })); });
    grid.appendChild(wk);
    var start = addDays(first, -dow(first)), cells = [], row;
    for (var i = 0; i < 42; i++) {
      var ds = addDays(start, i);
      if (i % 7 === 0) { if (ds.slice(0, 7) > ym) break; row = el('div', { class: 'rb-cal__row', role: 'row' }); grid.appendChild(row); }
      var inMonth = ds.slice(0, 7) === ym, info = byDate[ds], n = info ? info.slots.length : 0;
      var label = this.fmtDate(ds, { weekday: 'long', month: 'long', day: 'numeric' }) + (n ? ', ' + n + ' time' + (n > 1 ? 's' : '') + ' available' : (info && info.holiday ? ', closed for ' + info.holiday : ', unavailable'));
      var b = el('button', { type: 'button', role: 'gridcell', class: 'rb-day' + (inMonth ? '' : ' is-outside') + (n ? ' is-open' : '') + (ds === today ? ' is-today' : '') + (ds === this.state.date ? ' is-selected' : ''), 'data-date': ds, 'aria-label': label, 'aria-selected': ds === this.state.date ? 'true' : 'false', 'aria-disabled': n ? null : 'true', tabindex: '-1' }, [el('span', { text: String(+ds.slice(8)) }), info && info.holiday ? el('span', { class: 'rb-day__hol', 'aria-hidden': 'true' }) : null]);
      if (!inMonth) b.style.visibility = 'hidden';
      cells.push(b); row.appendChild(b);
    }
    C.appendChild(grid);
    var focusDate = this.state.date || (cells.filter(function (c) { return c.classList.contains('is-open'); })[0] || {}).dataset;
    var tabCell = cells.filter(function (c) { return c.dataset.date === (typeof focusDate === 'string' ? focusDate : focusDate && focusDate.date); })[0] || cells.filter(function (c) { return !c.classList.contains('is-outside'); })[0];
    if (tabCell) tabCell.tabIndex = 0;
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.rb-day'); if (!b || b.getAttribute('aria-disabled') === 'true') return;
      self.state.date = b.dataset.date; self.drawMonth(); self.drawTimes(true);
    });
    grid.addEventListener('keydown', function (e) {
      var b = e.target.closest('.rb-day'); if (!b) return;
      var delta = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
      if (e.key === 'Home') delta = -dow(b.dataset.date); if (e.key === 'End') delta = 6 - dow(b.dataset.date);
      if (delta == null) return;
      e.preventDefault();
      var target = addDays(b.dataset.date, delta);
      var nb = grid.querySelector('[data-date="' + target + '"]');
      if (nb && !nb.classList.contains('is-outside')) { b.tabIndex = -1; nb.tabIndex = 0; nb.focus(); }
    });
    this.drawTimes(false);
  };

  Booking.prototype.drawTimes = function (fromClick) {
    var self = this, T = this.$.times, data = this.monthData();
    T.innerHTML = '';
    if (!this.state.date) { T.appendChild(el('p', { class: 'rb-fine rb-times__hint', text: this.state.loading ? this.t('loading') : 'Select a highlighted date to see times.' })); return; }
    var day = data && data.days.filter(function (d) { return d.date === self.state.date; })[0];
    T.appendChild(el('h3', { class: 'rb-times__title', text: this.fmtDate(this.state.date, { weekday: 'long', month: 'long', day: 'numeric' }) }));
    if (!day || !day.slots.length) { T.appendChild(el('p', { class: 'rb-fine', text: day && day.holiday ? this.t('closedDay') + ' · ' + day.holiday : this.t('noTimes') })); return; }
    var parts = { Morning: [], Afternoon: [], Evening: [] };
    day.slots.forEach(function (s) { var h = +new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', hourCycle: 'h23' }).format(new Date(s.start)); parts[h < 12 ? 'Morning' : h < 17 ? 'Afternoon' : 'Evening'].push(s); });
    Object.keys(parts).forEach(function (p) {
      if (!parts[p].length) return;
      T.appendChild(el('p', { class: 'rb-times__part', text: p }));
      var ul = el('ul', { class: 'rb-slots', role: 'list' });
      parts[p].forEach(function (s) {
        var ms = Date.parse(s.start);
        var seats = self.state.type.capacity > 1 && s.seatsLeft === 1 ? el('span', { class: 'rb-slot__seats', text: '1 spot left' }) : null;
        ul.appendChild(el('li', null, [el('button', { type: 'button', class: 'rb-slot', 'aria-label': self.fmtSlot(ms) + ', ' + self.fmtDate(self.state.date, { weekday: 'long', month: 'long', day: 'numeric' }), onclick: function () { self.pickSlot(s); } }, [self.fmtSlot(ms), seats])]));
      });
      T.appendChild(ul);
    });
    if (fromClick) {
      this.say(day.slots.length + ' times available on ' + this.fmtDate(this.state.date, { weekday: 'long', month: 'long', day: 'numeric' }));
      if (!window.matchMedia('(min-width: 750px)').matches) T.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  Booking.prototype.field = function (opts) {
    var id = 'rb-' + opts.name + '-' + Math.random().toString(36).slice(2, 7);
    var input = el(opts.multiline ? 'textarea' : 'input', { id: id, name: opts.name, type: opts.multiline ? null : (opts.type || 'text'), required: opts.required, autocomplete: opts.autocomplete, inputmode: opts.inputmode, rows: opts.multiline ? 3 : null, maxlength: opts.multiline ? 2000 : 200, class: 'rb-input', oninput: function () { input.removeAttribute('aria-invalid'); } });
    return el('div', { class: 'rb-field' }, [el('label', { for: id, class: 'rb-label' }, [opts.label, opts.required ? null : el('span', { class: 'rb-opt', text: ' (' + this.t('optional') + ')' })]), input]);
  };

  Booking.prototype.drawDetails = function (B) {
    var self = this, t = this.state.type;
    B.appendChild(el('h2', { class: 'rb-h', text: this.t('details') }));
    var form = el('form', { class: 'rb-form', novalidate: true });
    if (t.nameFormat === 'first_last') {
      form.appendChild(el('div', { class: 'rb-grid2' }, [this.field({ name: 'firstName', label: 'First name', required: true, autocomplete: 'given-name' }), this.field({ name: 'lastName', label: 'Last name', required: true, autocomplete: 'family-name' })]));
    } else form.appendChild(this.field({ name: 'name', label: this.t('name'), required: true, autocomplete: 'name' }));
    form.appendChild(this.field({ name: 'email', label: this.t('email'), type: 'email', required: true, autocomplete: 'email', inputmode: 'email' }));
    (t.questions || []).forEach(function (q) { form.appendChild(self.field({ name: 'q_' + q.id, label: q.label, required: q.required, type: q.type === 'phone' ? 'tel' : 'text', autocomplete: q.type === 'phone' ? 'tel' : null, inputmode: q.type === 'phone' ? 'tel' : null, multiline: q.type === 'textarea' })); });
    if (t.allowGuests) {
      var gField = this.field({ name: 'guests', label: 'Guest emails (up to 10, separated by commas)', required: false, type: 'text', autocomplete: 'off', inputmode: 'email', multiline: true });
      gField.hidden = true;
      var gBtn = el('button', { type: 'button', class: 'rb-link rb-add-guests', text: '+ Add guests', onclick: function () { gField.hidden = false; gBtn.hidden = true; gField.querySelector('textarea').focus(); } });
      form.appendChild(gBtn); form.appendChild(gField);
    }
    // Honeypot: invisible to people, irresistible to bots.
    form.appendChild(el('div', { class: 'rb-hp', 'aria-hidden': 'true' }, [el('label', { text: 'Website' }, [el('input', { name: 'website', tabindex: '-1', autocomplete: 'off' })])]));
    form.appendChild(el('p', { class: 'rb-form-error', role: 'alert', 'data-rb-form-error': true }));
    form.appendChild(el('div', { class: 'rb-actions' }, [
      el('button', { type: 'button', class: 'rb-link', text: '← ' + this.t('back'), onclick: function () { self.state.slot = null; self.openCalendar(); } }),
      el('button', { type: 'submit', class: 'btn rb-submit', text: this.t('confirm') })
    ]));
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var bad = Array.prototype.filter.call(form.querySelectorAll('[required]'), function (i) { return !i.value.trim() || (i.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(i.value.trim())); });
      bad.forEach(function (i) { i.setAttribute('aria-invalid', 'true'); });
      if (bad.length) { form.querySelector('[data-rb-form-error]').textContent = self.t('check'); bad[0].focus(); return; }
      self.submit(form);
    });
    B.appendChild(form);
  };

  Booking.prototype.calLinks = function (b) {
    var f = function (iso) { return iso.replace(/[-:]/g, '').replace(/\.\d{3}/, ''); };
    var loc = b.meetingUrl || (b.location && b.location.label) || '';
    var g = 'https://calendar.google.com/calendar/render?action=TEMPLATE&text=' + encodeURIComponent(b.typeTitle + ' — Rudix Jewellery') + '&dates=' + f(b.start) + '/' + f(b.end) + '&location=' + encodeURIComponent(loc) + '&details=' + encodeURIComponent((b.hostName ? b.typeTitle + ' with ' + b.hostName : b.typeTitle) + (b.meetingUrl ? '\n' + b.meetingUrl : '')) + '&ctz=' + TZ;
    var ics = ['BEGIN:VCALENDAR', 'VERSION:2.0', 'PRODID:-//Rudix Booking//EN', 'BEGIN:VEVENT', 'UID:' + b.id + '@rudix-booking', 'DTSTAMP:' + f(new Date().toISOString()), 'DTSTART:' + f(b.start), 'DTEND:' + f(b.end), 'SEQUENCE:0', 'SUMMARY:' + b.typeTitle + (b.hostName ? ' with ' + b.hostName : '') + ' — Rudix Jewellery', 'ORGANIZER;CN=' + (b.hostName || 'Rudix Jewellery') + ':mailto:info@rudixjewellery.com', 'LOCATION:' + loc.replace(/,/g, '\\,'), 'END:VEVENT', 'END:VCALENDAR'].join('\r\n');
    return { google: g, ics: 'data:text/calendar;charset=utf-8,' + encodeURIComponent(ics) };
  };

  Booking.prototype.drawDone = function (B) {
    var b = this.state.booking, self = this;
    if (!b) { B.appendChild(el('h2', { class: 'rb-h', text: this.t('done') })); return; }
    var st = Date.parse(b.start), links = this.calLinks(b);
    B.appendChild(el('div', { class: 'rb-done' }, [
      el('span', { class: 'rb-done__mark', 'aria-hidden': 'true' }),
      el('h2', { class: 'rb-h', text: this.t('done') }),
      el('p', { class: 'rb-done__lead', text: 'A confirmation is on its way to ' + b.email + '.' }),
      el('dl', { class: 'rb-dl' }, [
        el('dt', { text: 'Appointment' }), el('dd', { text: b.typeTitle + ' · ' + b.durationMin + ' ' + this.t('min') }),
        el('dt', { text: 'When' }), el('dd', { text: this.fmtWhen(st) }),
        el('dt', { text: 'Where' }), el('dd', null, [b.location.kind === 'phone_outbound' ? 'We’ll call you' : b.meetingUrl ? el('a', { href: b.meetingUrl, target: '_blank', rel: 'noopener', text: 'Google Meet: ' + b.meetingUrl }) : b.location.label]),
        b.hostName ? el('dt', { text: 'With' }) : null, b.hostName ? el('dd', { text: b.hostName }) : null,
        (b.guests || []).length ? el('dt', { text: 'Guests' }) : null, (b.guests || []).length ? el('dd', { text: b.guests.join(', ') }) : null
      ].concat((b.answers || []).reduce(function (a, x) { return a.concat([el('dt', { text: x.label }), el('dd', { class: 'rb-pre', text: x.value })]); }, []))),
      (this.state.type && this.state.type.description) ? el('p', { class: 'rb-fine rb-pre', text: this.state.type.description }) : null,
      el('div', { class: 'rb-actions rb-actions--start' }, [
        el('a', { class: 'btn btn--secondary rb-btn-alt', href: links.google, target: '_blank', rel: 'noopener', text: 'Add to Google Calendar' }),
        el('a', { class: 'btn btn--secondary rb-btn-alt', href: links.ics, download: 'rudix-appointment.ics', text: 'Apple / Outlook (.ics)' })
      ]),
      this.state.manageToken ? el('p', { class: 'rb-fine' }, ['Need to change it? ', el('a', { href: this.linkTo({ manage: this.state.manageToken, action: 'reschedule' }), text: 'Reschedule' }), ' or ', el('a', { href: this.linkTo({ manage: this.state.manageToken, action: 'cancel' }), text: 'cancel' }), '.']) : null,
      el('button', { type: 'button', class: 'rb-link', text: 'Book another appointment', onclick: function () { self.state = { step: 'type', days: {}, renderedAt: Date.now(), idem: uuid() }; self.render('type'); } })
    ]));
  };

  Booking.prototype.drawManage = function (B, extra) {
    var self = this, b = this.state.manage.booking, st = Date.parse(b.start);
    var cancelled = b.status === 'cancelled', past = st < Date.now();
    B.appendChild(el('h2', { class: 'rb-h', text: cancelled ? 'Appointment cancelled' : (extra.rescheduled ? 'Appointment moved' : 'Your appointment') }));
    B.appendChild(el('dl', { class: 'rb-dl' }, [
      el('dt', { text: 'Appointment' }), el('dd', { text: b.typeTitle }),
      el('dt', { text: 'When' }), el('dd', { text: this.fmtWhen(st) }),
      el('dt', { text: 'Name' }), el('dd', { text: b.name }),
      b.meetingUrl && !cancelled ? el('dt', { text: 'Google Meet' }) : null,
      b.meetingUrl && !cancelled ? el('dd', null, [el('a', { href: b.meetingUrl, target: '_blank', rel: 'noopener', text: b.meetingUrl })]) : null
    ]));
    if (cancelled) { B.appendChild(el('a', { class: 'btn', href: this.linkTo({}), text: 'Book a new time' })); return; }
    if (past) { B.appendChild(el('p', { class: 'rb-fine', text: 'This appointment has already started. Please contact us for changes.' })); return; }
    var confirmBox = el('div', { class: 'rb-confirm', hidden: true }, [
      el('div', { class: 'rb-field' }, [el('label', { class: 'rb-label', for: 'rb-reason', text: 'Reason (optional)' }), el('textarea', { id: 'rb-reason', name: 'reason', class: 'rb-input', rows: 2, maxlength: 500 })]),
      el('div', { class: 'rb-actions rb-actions--start' }, [el('button', { type: 'button', class: 'btn', text: 'Yes, cancel appointment', onclick: function () { self.doCancel(); } }), el('button', { type: 'button', class: 'rb-link', text: 'Keep it', onclick: function () { confirmBox.hidden = true; } })])
    ]);
    B.appendChild(el('div', { class: 'rb-actions rb-actions--start' }, [
      el('button', { type: 'button', class: 'btn', text: 'Reschedule', onclick: function () { self.state.rescheduling = true; self.state.date = null; self.state.days = {}; self.openCalendar(); } }),
      el('button', { type: 'button', class: 'btn btn--secondary rb-btn-alt', text: 'Cancel appointment', onclick: function () { confirmBox.hidden = false; confirmBox.querySelector('textarea').focus(); } })
    ]));
    B.appendChild(confirmBox);
    if (new URLSearchParams(location.search).get('action') === 'cancel') { confirmBox.hidden = false; }
  };

  Booking.prototype.drawConfirmReschedule = function (B) {
    var self = this, b = this.state.manage.booking, ns = Date.parse(this.state.slot.start), os = Date.parse(b.start);
    B.appendChild(el('h2', { class: 'rb-h', text: 'Confirm new time' }));
    B.appendChild(el('dl', { class: 'rb-dl' }, [el('dt', { text: 'From' }), el('dd', { class: 'rb-strike', text: this.fmtWhen(os, { weekday: 'short', month: 'short', day: 'numeric' }) }), el('dt', { text: 'To' }), el('dd', { text: this.fmtWhen(ns, { weekday: 'long', month: 'long', day: 'numeric' }) })]));
    B.appendChild(el('div', { class: 'rb-field' }, [el('label', { class: 'rb-label', for: 'rb-rsreason' }, ['Reason for rescheduling', el('span', { class: 'rb-opt', text: ' (' + this.t('optional') + ')' })]), el('textarea', { id: 'rb-rsreason', name: 'rsreason', class: 'rb-input', rows: 2, maxlength: 500 })]));
    B.appendChild(el('div', { class: 'rb-actions rb-actions--start' }, [el('button', { type: 'button', class: 'btn', text: 'Confirm new time', onclick: function () { self.doReschedule(); } }), el('button', { type: 'button', class: 'rb-link', text: '← ' + this.t('back'), onclick: function () { self.openCalendar(); } })]));
  };

  // Remember UTM / gclid for the session so attribution survives page hops.
  try { var sp = new URLSearchParams(location.search); ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'].forEach(function (k) { if (sp.get(k)) sessionStorage.setItem('rb_' + k, sp.get(k)); }); } catch (e) {}

  function boot() { document.querySelectorAll('[data-rudix-booking]:not([data-rb-ready])').forEach(function (r) { r.setAttribute('data-rb-ready', ''); r.__rb = new Booking(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();